import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import { getComputerFormattedTime } from 'src/domain/date/date';
import { SyncStatus } from 'src/domain/pjm/dto/SyncStatus';

export interface IDrhubSyncStatusProps {
    value: {
        syncDrhubStatus: SyncStatus;
        syncDrhubDate?: Date;
        syncDrhubError?: string;
    };
}

export const DrhubSyncStatus = ({ value }: IDrhubSyncStatusProps) => {
    if (!value.syncDrhubStatus) return <></>;

    let color = 'blue';
    let tooltip: React.ReactElement = <></>;
    switch (value.syncDrhubStatus) {
        case SyncStatus.PENDING:
            color = 'default';
            tooltip = (
                <>
                    <div>Changes have not yet been synced to DRHUB.</div>
                </>
            );
            break;
        case SyncStatus.SUCCESS:
            color = 'cyan';
            tooltip = (
                <>
                    <div>Changes have been synced to DRHUB</div>
                    <div>{value.syncDrhubDate ? getComputerFormattedTime(value.syncDrhubDate) : ''}</div>
                </>
            );
            break;
        case SyncStatus.FAILED:
            color = 'volcano';
            tooltip = (
                <>
                    <div>Synchronization with DRHUB failed: {value.syncDrhubError}</div>
                    <div>{value.syncDrhubDate ? getComputerFormattedTime(value.syncDrhubDate) : ''}</div>
                </>
            );
            break;
    }

    return (
        <Tooltip title={tooltip}>
            <Tag color={color}>{value.syncDrhubStatus}</Tag>
        </Tooltip>
    );
};
